import { gql } from "@stadium/services/apollo-client";

export const MODIFY_USER = gql`
  mutation modifyUser($input: ModifyUserInput!) {
    modifyUser(input: $input) {
      errors
      success
      user {
        id
        customizerGuideTourCompleted
        marketingAnnouncementViewed
        automatedCatalogBannerDismissed
        automatedCatalogGuideTourViewed
        automatedCatalogFooterCartGuideTourViewed
        automatedCatalogLogoDragTooltipViewed
      }
    }
  }
`;
